
import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import useInboxChatListActions from '../actions/useInboxChatListActions';

/**
 * Hook de UI para InboxChatListMC
 * Solo maneja estado visual y orquesta handlers importados
 */
export default function useInboxChatListUI() {
  const { selectedConversationId } = useSelector(
    (reduxState) => reduxState.conversationsReducer
  );
  const { handleSelectConversation } = useInboxChatListActions();
  // Estado visual: conversación seleccionada (normaliza ambos a string)
  const isSelected = useCallback(
    (conversationId) => String(selectedConversationId) === String(conversationId),
    [selectedConversationId]
  );

  // Memoización de props visuales
  return useMemo(() => ({
    handleSelectConversation,
    isSelected,
  }), [handleSelectConversation, isSelected]);
}
